import React from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import "./App.css";

import Header from "./Header";
import { AuthProvider } from "./AuthContext";
import { ThemeProvider } from "./ThemeContext";
import LandingPage from "./LandingPage";
import GenerateRestaurants from "./GenerateRestaurants";

import Footer from "./Footer";
import Pricingpage from "./Pricingpage";
import ProtectedRoute from "./ProtectedRoute";
import PrivacyPolicy from "./trustpages/PrivacyPolicy";
import TermsOfService from "./trustpages/TermsOfService";
import FAQ from "./trustpages/FAQ";
import ContactandSupport from "./trustpages/ContactandSupport";
function App() {
  const location = useLocation();
  const isLeadsPage = location.pathname === "/generate-leads";
  const isFullPage  = isLeadsPage;

  return (
    <AuthProvider>
      <ThemeProvider>
        <div className="App">
          {!isFullPage && <Header />}

          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/pricing-plans" element={<Pricingpage />} />
            <Route path="/privacy-page" element={<PrivacyPolicy/>}/>
            <Route path="/terms-of-service" element={<TermsOfService/>}/>
              <Route path="/contact-support" element={<ContactandSupport/>}/>
            
            <Route path="/faq-support" element={<FAQ/>}/>
            {/* Protected — must be signed in */}
            <Route
              path="/generate-leads"
              element={
                <ProtectedRoute>
                  <GenerateRestaurants />
                </ProtectedRoute>
              }
            />

           
            
          </Routes>

          {!isFullPage && <Footer />}
        </div>
      </ThemeProvider>
    </AuthProvider>
  );
}

export default App;